import { getCookie } from 'cookies-next';
export var inContextEditorEnabled = getCookie('enableInContextEditor')
    ? true
    : false;
